module.exports = "//static.hsappstatic.net/growth-onboarding-confetti/static-1.643/images/sprocket.svg"